import { useOutletContext } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function AccountSettings() {
  const { me } = useOutletContext();
  return (
    <div className="space-y-6" data-testid="account-settings-page">
      <div>
        <h1 className="font-display font-bold text-2xl sm:text-3xl text-slate-900 tracking-tight">Account settings</h1>
        <p className="text-slate-600 mt-2 text-sm">Your identity is managed by Emergent-managed Auth. Use the user menu to change email or password.</p>
      </div>
      <Card className="p-6 border-slate-200">
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-sm">
          <Field label="Email" value={me?.email || "—"} />
          <Field label="Name" value={[me?.first_name, me?.last_name].filter(Boolean).join(" ") || "—"} />
          <Field label="Role" value={<Badge variant="outline" className="border-slate-200">{me?.role || "member"}</Badge>} />
          <Field label="Free attempts remaining" value={me?.free_attempts_remaining ?? 3} />
          <Field label="Exam families" value={(me?.selected_families || []).join(", ") || "—"} />
          <Field label="Subjects chosen" value={me?.selected_subjects?.length || 0} />
        </dl>
      </Card>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-wider text-slate-500 font-medium">{label}</dt>
      <dd className="mt-1 text-slate-900">{value}</dd>
    </div>
  );
}
